module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-comment txt-left"
  }, [_c('el-popover', {
    ref: "tooltip",
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "effect": "dark",
      "content": _vm.tooltip
    }
  }), _c('div', {
    staticClass: "ml-15 question-comment__button txt-center@xs txt-center@md no-print"
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      arg: "tooltip"
    }],
    staticClass: "btn btn--text btn--round add-comment",
    on: {
      "click": function($event) {
        return _vm.openDialog()
      }
    }
  }, [_c('i', {
    staticClass: "fa no-print",
    class: _vm.commentClass
  })])], 1), _c('el-dialog', {
    attrs: {
      "modal": false,
      "top": "30%",
      "custom-class": "showDialog",
      "before-close": _vm.closeDialog
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.commentTitle))]), _c('div', {
    staticClass: "form-group"
  }, [_c('float-label', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempComment),
      expression: "tempComment"
    }],
    staticClass: "form-group__textarea",
    attrs: {
      "rows": "5",
      "placeholder": "Comment"
    },
    domProps: {
      "value": (_vm.tempComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tempComment = $event.target.value
      }
    }
  })])], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setQuestionComment()
      }
    }
  }, [_vm._v("Confirm")])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComment),
      expression: "showComment"
    }],
    staticClass: "gr-12 print-only"
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" " + _vm._s(_vm.question.comment))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1fb4408","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-comment.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f1fb4408","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-comment.vue
// module chunks = 0